
















import { Vue, Component, Prop } from "vue-property-decorator"

@Component({})
export default class PageHeader extends Vue {
    /**
     * eg: https://www.antdv.com/components/breadcrumb-cn/
     */
    @Prop({ type: String }) title?: string
    @Prop({ type: String }) subTitle?: string
    @Prop({ type: Boolean, default: false }) isBack?: boolean

    goBack() {
        this.$emit("goBack")
    }
}
